<div class="footerCont">
  <p class="fineprint">
    &#64;DMINT Copyright
    <span>{{ currentYear }}</span
    >. All Rights Reserved.
  </p>
</div>
